import type { Tracer } from '@opentelemetry/api';
import { sanitizeAxiosError, scrubUnknownToString } from './logScrubber';

// Share the exact same redacted text with the console and telemetry exporter.
export function captureConsoleLogs(tracer: Tracer): () => void {
  const methods = ['log', 'info', 'warn', 'error', 'debug'] as const;
  const originals = methods.map((method) => console[method]);
  methods.forEach((method, index) => {
    console[method] = (...args: unknown[]) => {
      const safeArgs = args.map((arg) => {
        const isError = arg instanceof Error || (arg && typeof arg === 'object' && 'isAxiosError' in arg);
        return scrubUnknownToString(isError ? sanitizeAxiosError(arg) : arg, 2048);
      });
      originals[index].apply(console, safeArgs);
      const message = safeArgs.join(' ').slice(0, 8192);
      const span = tracer.startSpan(message || `console.${method}`);
      span.setAttribute('log.severity', method === 'log' ? 'info' : method);
      span.setAttribute('log.message', message);
      span.end();
    };
  });
  return () => methods.forEach((method, index) => { console[method] = originals[index]; });
}
